module.exports = __webpack_public_path__ + "img/eg_mob_wallets.02ccb09e.png";